import { createClient } from '@/shared/api';
import type { UnreadInboxCountsQuery, UnreadInboxCountsQueryVariables } from '@/shared/api';
import UNREAD_INBOX_COUNTS_QUERY from '../queries/unreadInboxCounts';

/**
 * Loads the number of unread inbox reports matching a filter. Runs the unreadInboxCounts query and throws the returned message unless it reports success, otherwise yielding the count.
 *
 * @param filter - Filter narrowing the counted inbox reports.
 * @returns A promise resolving to the unread inbox count.
 */
const fetchUnreadInboxCounts = async (
  filter: UnreadInboxCountsQueryVariables['filter'],
): Promise<NonNullable<UnreadInboxCountsQuery['unreadInboxCounts']>['count']> => {
  const client = createClient();
  const result = await client.query<UnreadInboxCountsQuery, UnreadInboxCountsQueryVariables>({
    query: UNREAD_INBOX_COUNTS_QUERY,
    variables: { filter },
  });
  const { data } = result;
  // API always returns this field for a resolved query; code already accessed it unconditionally.
  const { unreadInboxCounts } = data;
  if (!unreadInboxCounts!.isSuccess) {
    throw new Error(unreadInboxCounts!.message ?? undefined);
  }
  return unreadInboxCounts!.count;
};

export default fetchUnreadInboxCounts;
